var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-nav-bar',{attrs:{"title":_vm.titleTex},on:{"click-left":_vm.onClickLeft},scopedSlots:_vm._u([{key:"left",fn:function(){return [_c('img',{staticStyle:{"width":"2.66667vw","height":"5.33333vw","display":"inline-block"},attrs:{"src":require('../assets/'+_vm.appTheme+'/right_icon2.png'),"alt":""}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }